<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    const path =  process.env.VUE_APP_SERVICE_URL;
    this.$resPost(this.$api.GetConf).then(res => {
         $("meta[name='keywords']").attr("content", res.Data.KeyWords);
      $("meta[name='description']").attr("content", res.Data.Description);
      var icons = $(
        `
    <link rel="icon" type="image/png" href="` +
          path +
          res.Data.Icon16 +
          `" sizes="16x16" />
    <link rel="icon" type="image/png" href="` +
          path +
          res.Data.Icon32 +
          `" sizes="32x32" />
    <link rel="icon" type="image/png" href="` +
          path +
          res.Data.Icon64 +
          `" sizes="64x64" />
    `
      );
      $("head").append(icons);
      $("title").text(res.Data.Title);
    })
  },
};
</script>

<style lang="less">
</style>
